$.onmount('[role=shipment-invoice-search]', function () {
  var $form = $(this)
  var url = $form.attr('action')

  $form.on('submit', function (e) {
    submit(url + '?' + $form.serialize())

    e.preventDefault()
  })

  $('body').on('click', '.pagination a, th > a', function (e) {
    e.preventDefault()
    e.stopPropagation()
    $el = $(this)

    if ( $el.attr('href') ) {
      submit( $(this).attr('href') )
    }
  })

  $('body').on('change', 'input[type=checkbox][data-role=invoice-checkbox]', function () {
    var id = $(this).closest('tr').data('id');
    sessionStorage.shipmentInvoices = sessionStorage.shipmentInvoices || "[]";

    var ids = JSON.parse(sessionStorage.shipmentInvoices);

    if (this.checked) {
      if (!ids.includes(id)) ids.push(id);
      $(this).closest('tr').addClass('active');
    } else {
      ids = _.without(ids, id);
      $(this).closest('tr').removeClass('active');
    }

    sessionStorage.shipmentInvoices = JSON.stringify(ids);

    // Update export button
    if (ids.length > 0) {
      $('[data-role=export]').removeClass('d-none');
      $('[data-role=export] .count').text(ids.length);
    } else {
      $('[data-role=export]').addClass('d-none');
    }
  });

  $('[data-role=export]').on('click', function(e){
    e.preventDefault();
    var ids = JSON.parse(sessionStorage.shipmentInvoices || '[]');

    var exportUrl = $(this).attr('href');
    // Add shipment_invoice_ids[] as query params
    var params = ids.map(function(id){ return 'shipment_invoice_ids[]=' + id; }).join('&');
    window.location.href = exportUrl + '?' + params;
  })

  var submit = function (searchUrl) {
    console.log( searchUrl )
    $.ajax({
      url: searchUrl,
      cache: false,
      dataType: 'JSON',
      success: function (data) {
        onSuccess(searchUrl, data)
      },
      complete: function () {
        $.onmount()
      }
    })
  }

 var onSuccess = function (searchUrl, data) {
    $('[role=shipment-invoice-search-list]').html(data.list);

    $.onmount();      // <-- must be here, after HTML is injected
    refresh();        // now refresh finds checkboxes

    $.rails.enableFormElements($form);
    window.history.pushState('', '', searchUrl);
  };

  var refresh = function () {
    sessionStorage.shipmentInvoices = sessionStorage.shipmentInvoices || "[]";

    var ids = JSON.parse(sessionStorage.shipmentInvoices);

    _.each(ids, function (id) {
      $('tr[data-id=' + id + '] > td:first-child input[type=checkbox]').prop('checked', true)
      $('tr[data-id=' + id + ']').addClass('active')
    })

    if (ids.length > 0) {
      $('[data-role=export]').removeClass('d-none')
      $('[data-role=export] .count').text(ids.length)
    }

    $('[data-toggle=tooltip]').tooltip()
  }

  refresh();
})